var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11068",
    "data-name": "Group 11068",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.354,
    height: 20.24,
    viewBox: "0 0 23.354 20.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3266",
    "data-name": "Rectangle 3266",
    width: 23.354,
    height: 20.24,
    fill: "#5a5a5a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11067",
    "data-name": "Group 11067",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29017",
    "data-name": "Path 29017",
    d: "M23.35,3.846l0-.019a3.935,3.935,0,0,0-1.129-2.691A3.935,3.935,0,0,0,19.462,0H3.892A3.935,3.935,0,0,0,1.136,1.136,3.935,3.935,0,0,0,.006,3.827l0,.019c0,.016,0,.031,0,.047v9.342a3.877,3.877,0,0,0,3.892,3.892h8.3a.778.778,0,1,0,0-1.557h-8.3a2.339,2.339,0,0,1-2.335-2.335V5.149L9.933,9.342c.008,0,.017.008.025.008a4.237,4.237,0,0,0,3.438,0c.008,0,.017-.008.025-.008L21.8,5.149v7.306a.778.778,0,1,0,1.557,0V3.892c0-.016,0-.031,0-.047M12.727,7.938a2.265,2.265,0,0,1-1.05.219,2.265,2.265,0,0,1-1.05-.219L1.6,3.436A2.342,2.342,0,0,1,3.892,1.557H19.462a2.342,2.342,0,0,1,2.291,1.879Z",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29018",
    "data-name": "Path 29018",
    d: "M19.472,12.227a.779.779,0,0,0-1.1,1.1l1.787,1.784H15.028a.778.778,0,1,0,0,1.557h5.129L18.37,18.455a.779.779,0,0,0,1.1,1.1l2.012-2.015a2.33,2.33,0,0,0,0-3.3Z",
    transform: "translate(0.541 0.456)",
    fill: "#5a5a5a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mailIcon.85e9c3b8df4b7ce40ce79a9e60de1b41.svg";
export { ForwardRef as ReactComponent };